import React, { useContext } from 'react';
import { MyContext } from '../../context';

function TermsAndConditions() {
  const { pageData } = useContext(MyContext);

  return (
    <section className="commonConditions">
      <div className="container">
        <div className="smallContainer">
          <h1 style={{ textAlign: 'center' }}>
            {pageData?.inspectionTerms?.header}
          </h1>
          {pageData?.inspectionTerms?.contentArray?.map((data, index) => (
            <p key={index}>{data?.data}</p>
          ))}
          <h2 style={{ marginTop: '1rem' }}>
            {pageData?.inspectionTerms?.subHeader}
          </h2>
          <ol style={{ paddingTop: '0px' }}>
            {pageData?.inspectionTerms?.listContent?.map((data, index) => (
              <li style={{ listStyleType: 'disc' }}>
                <p> {data}</p>
              </li>
            ))}
          </ol>
          <h2 style={{ marginTop: '1rem' }}>
            {pageData?.inspectionTerms?.subHeader1}
          </h2>
          <p>
            <strong>{pageData?.inspectionTerms?.subTitle}</strong>
          </p>
          <ol style={{ paddingTop: '0px' }}>
            {pageData?.inspectionTerms?.listExcluded?.map((data, index) => (
              <li style={{ listStyleType: 'disc' }}>
                <p> {data}</p>
              </li>
            ))}

            <li style={{ listStyleType: 'disc' }}>
              <p>{pageData?.inspectionTerms?.subheader2}</p>
              <ol style={{ marginLeft: '20px' }}>
                {pageData?.inspectionTerms?.inspectionCannotListItems?.map(
                  (data, index) => (
                    <li style={{ listStyleType: 'disc' }}>
                      <p>{data}</p>
                    </li>
                  )
                )}
              </ol>
            </li>
            {pageData?.inspectionTerms?.listContent1?.map((data, index) => (
              <li style={{ listStyleType: 'disc' }}>
                <p>{data}</p>
              </li>
            ))}
            <p>{pageData?.inspectionTerms?.subHeader3}</p>

            {pageData?.inspectionTerms?.listContent2?.map((data, index) => (
              <li style={{ listStyleType: 'disc' }}>
                <p>{data}</p>
              </li>
            ))}
          </ol>

          <h2 style={{ marginTop: '1rem' }}>
            {pageData?.inspectionTerms?.subHeader4}
          </h2>
          <ol>
            {pageData?.inspectionTerms?.listContent3?.map((data, index) => (
              <li style={{ listStyleType: 'disc' }}>
                <p>{data}</p>
              </li>
            ))}
          </ol>

          <h2 style={{ marginTop: '1rem' }}>
            {pageData?.inspectionTerms?.subHeader5}{' '}
          </h2>

          <ol>
            {pageData?.inspectionTerms?.listContent4?.map((data, index) => (
              <li style={{ listStyleType: 'disc' }}>
                <p>{data}</p>
              </li>
            ))}
          </ol>
          <h2 style={{ marginTop: '1rem' }}>
            {pageData?.inspectionTerms?.subHeader6}
          </h2>
          <ol>
            {pageData?.inspectionTerms?.listContent5?.map((data, index) => (
              <li style={{ listStyleType: 'disc' }}>
                <p>{data}</p>
              </li>
            ))}
          </ol>

          <h2 style={{ marginTop: '1rem' }}>
            {pageData?.inspectionTerms?.subHeader7}
          </h2>

          <ol>
            {pageData?.inspectionTerms?.listContent6?.map((data, index) => (
              <li style={{ listStyleType: 'disc' }}>
                <p>{data}</p>
              </li>
            ))}
          </ol>
          <h2 style={{ marginTop: '1rem' }}>
            {pageData?.inspectionTerms?.subHeader8}
          </h2>
          <ol>
            {pageData?.inspectionTerms?.listContent7?.map((data, index) => (
              <li style={{ listStyleType: 'disc' }}>
                <p>{data}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}

export default TermsAndConditions;
